/**
 * @file routes.ts
 *
 * @fileoverview Include routes for the application.
 */
const wdMainRoutesConfig = require('./../routes');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

module.exports = mergeDeepRight(wdMainRoutesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  frontendSpecificRedirects: [
    // robots.txt redirect
    {
      source: '/robots.txt',
      destination: `/static/diversityconnect/robots.txt`,
      permanent: true,
    },
  ],
});
